import MHSubscribe from "../components/Layout/MHSubscribe";
import MHFooter from "../components/Layout/MHFooter";
import React from "react";
import HeroSection from "../components/NewLanding/HeroSection";
import FeaturedCompanies from "../components/Landing/FeaturedCompanies";
import { Box } from "@mui/material";
import HeroSlider from "../components/Landing/HeroSlider";
import MorganStanleyPress from "../components/NewLanding/MorganStanleyPress";
import EventGlance from "../components/NewLanding/EventGlance";
import LandingPodcast from "../components/NewLanding/LandingPodcast";
import PodcastSubscribe from "../components/NewLanding/PodcastSubscribe";
import NigeriaCarePolicy from "../components/NewLanding/NigeriaCarePolicy";
// import { getCookie } from "../hooks/use-cookie";

const Index = () => {
  // const [timer, setTimer] = React.useState(false);
  // const [newsTimer, setNewsTimer] = React.useState(false);
  // const [subTimer, setSubTimer] = React.useState(false);
  // const [toolTimer, setToolTimer] = React.useState(false);

  // const cookieValue = getCookie("_mhCookie");

  // React.useEffect(() => {
  //   if (cookieValue === "") {
  //     const timer = setTimeout(() => {
  //       setTimer(true);
  //     }, 1000);
  //     return () => clearTimeout(timer);
  //   } else {
  //     setTimer(false);
  //     return;
  //   }
  // }, []);

  // React.useEffect(() => {
  //   if (cookieValue === "") {
  //     const newsTimer = setTimeout(() => {
  //       setNewsTimer(true);
  //     }, 3000);
  //     return () => clearTimeout(newsTimer);
  //   } else {
  //     setNewsTimer(false);
  //     return;
  //   }
  // }, []);

  // const handleLegalClose = () => {
  //   setTimer(false);
  // };
  // const handleNewsClose = () => {
  //   setNewsTimer(false);
  //   setSubTimer(true);
  // };
  // const handleSubClose = () => {
  //   setSubTimer(false);
  //   setToolTimer(true);
  // };
  // const handleToolClose = () => {
  //   setToolTimer(false);
  // };

  return (
    <React.Fragment>
      <HeroSection />
      {/* <MainView /> */}

      <HeroSlider />

      <Box mt={5} mb={7}>
        <FeaturedCompanies />
      </Box>

      <Box mt={5} mb={{ xs: 0, sm: 7 }}>
        <NigeriaCarePolicy />
      </Box>

      <MorganStanleyPress />

      <EventGlance />

      <LandingPodcast />

      <PodcastSubscribe />

      {/* FOOTER BEGINS */}
      <MHSubscribe />
      <MHFooter />
    </React.Fragment>
  );
};

export default Index;
